import React from 'react';
import Title from '../../atoms/title/title.js';

const Footer = ({ links, termsLinks, logo, companyInfo, socialLinks, logoAction }) => {
    return (React.createElement("footer", null,
        React.createElement("div", { className: "mbw-footer" },
            React.createElement("div", { className: "mbw-footer-logo-wrapper" },
                React.createElement("div", { className: "mbw-footer-logo", onClick: logoAction }, logo),
                React.createElement("div", { className: "mbw-footer-social-media" }, socialLinks?.map((appLinks) => {
                    return (React.createElement("a", { key: appLinks.key, href: appLinks.href, target: "_blank", rel: "noreferrer" }, appLinks.icon));
                }))),
            React.createElement("div", { className: "mbw-footer-links" }, links?.map((link) => (React.createElement("div", { className: "mbw-footer-link", key: link.title },
                React.createElement("div", { className: "mbw-footer-link-title" },
                    React.createElement(Title, { fontStyle: "content-default", bold: true }, link.title)),
                link.children.map((itemsLink) => (React.createElement("div", { key: itemsLink.name },
                    React.createElement(Title, { fontStyle: "heading-h6" },
                        React.createElement("a", { className: "mbw-footer-path", href: itemsLink.path }, itemsLink.name)))))))))),
        React.createElement("div", { className: "mbw-footer-terms" },
            React.createElement(Title, { fontStyle: "content-small" }, companyInfo),
            React.createElement("div", { className: "mbw-footer-terms-links" }, termsLinks?.map((term) => {
                return (React.createElement(Title, { key: term.path, fontStyle: "content-small" },
                    React.createElement("a", { href: term.path }, term.name)));
            })))));
};

export { Footer as default };
//# sourceMappingURL=footer.js.map
